import classNames from 'classnames';
import {useFormatNumber, useI18n} from '@udemy-v2/i18n';
import {UFBNoticeButton} from '@udemy-v2/organization-growth';
import React from 'react';
import styles from './marketplace-ufb-notice.module.scss';
import {CtaPlacement, useUbCtaParams} from '../../hooks/use-ub-cta-href';
import {useOrganizationStats} from '@udemy-v2/site-stats';

export const MarketplaceUfbNotice = () => {
    const {gettext, interpolate, locale} = useI18n();
    const {numCoursesRounded} = useOrganizationStats();
    const {formatNumber} = useFormatNumber();
    const formattedNumCoursesRounded = formatNumber(numCoursesRounded);
    const {ubHref, eventData} = useUbCtaParams({ctaPlacement: CtaPlacement.NON_PP_TRANSACTION});

    const config = {
        ja_JP: {
            href: 'https://ufb.benesse.co.jp/?ref=marketplace_control_lifestyle&amp;utm_source=marketplace&amp;utm_medium=referral&amp;utm_campaign=mx-hooks&amp;utm_content=clp&amp;utm_term=&amp;locale=ja_JP',
            minTeamUserCount: 20,
        },
        default: {
            href: ubHref,
            minTeamUserCount: 5,
        },
    };
    const {href, minTeamUserCount} = config[locale as keyof typeof config] || config.default;

    return (
        <div className={classNames(styles['notice-container'])}>
            <h2 className={classNames('ud-heading-lg')}>
                {interpolate(
                    gettext('Training %(minTeamUserCount)s or more people?'),
                    {minTeamUserCount},
                    true,
                )}
            </h2>
            <p className={classNames('ud-text-sm')}>
                {interpolate(
                    gettext(
                        'Get your team access to %(courseCount)s+ top Udemy courses anytime, anywhere.',
                    ),
                    {courseCount: formattedNumCoursesRounded},
                    true,
                )}
            </p>
            <UFBNoticeButton
                className={classNames(styles['notice-button'])}
                href={href}
                udStyle="secondary"
                eventData={eventData}
            />
        </div>
    );
};
